import { useQuery } from "@tanstack/react-query";

import { fetchDataGet } from "@/core/api/api-methods";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { walletEndpoints } from "@/features/wallet/api/endpoints";
import type { BeneficiaryDto } from "@/features/wallet/api/dto";

/**
 * Bénéficiaires enregistrés d'un portefeuille
 * (`GET /Beneficiaries/wallet/{walletId}`). Le numéro de compte est renvoyé
 * en clair, sa colonne de hash ne l'est jamais (guide §6.3).
 */
export const useWalletBeneficiaries = (walletId: string, enabled = true) =>
  useQuery({
    queryKey: QUERY_KEYS.WALLET_BENEFICIARIES(walletId),
    queryFn: async () => {
      const data = await fetchDataGet<BeneficiaryDto[] | BeneficiaryDto>({
        url: walletEndpoints.beneficiaries.byWallet(walletId),
      });
      // L'exemple Postman montre un objet unique : normalisation défensive
      // en liste (le contrat logique est « bénéficiaires d'un portefeuille »).
      if (Array.isArray(data)) return data;
      return data ? [data] : [];
    },
    retry: (failureCount, error) =>
      !/401/.test(error?.message ?? "") && failureCount < 1,
    enabled: enabled && Boolean(walletId),
  });
